module.exports = __webpack_public_path__ + "media/images/icons/arrow-thick-right-79e01d7b1c94323286a3ea68a9251cb5.svg";